import { useLocation } from 'react-router';
import { appRoutes } from '../constants/appRoutes';

export const useIsCanvasUnited = () => {
  const { pathname } = useLocation();
  const isCanvasUnited =
    pathname.includes(appRoutes.funnelEditor.route) ||
    pathname.includes(appRoutes.funnelEditorReadOnly.route);

  return isCanvasUnited;
};
